/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/pt-BR'



import {AppVisibility,AddressbarColor,AppFullscreen,Cookies,Dialog,Loading,LocalStorage,Notify,SessionStorage} from 'quasar'



export default { config: {"notify":{"color":"steel-grey-9"}},lang,plugins: {AppVisibility,AddressbarColor,AppFullscreen,Cookies,Dialog,Loading,LocalStorage,Notify,SessionStorage} }

